@if( project ) {
<main>
<h2>{{project.title}}</h2>

@if( bIsNewProject ) {
<p>Feel free to accept the defaults if you're uncertain. You'll be able to edit these values later.</p>
}

@if( userIsNotAdmin ) {
  <p class="warn">You are not an administrator of this project. You are free to look at the project settings, but you will not be allowed to save your changes.</p>
}

<form [formGroup]="form" (ngSubmit)="save()">
  <div id="buttons">
    @if( !bIsNewProject ) {
      <button mat-button (click)="resetData()" type="button">Discard Changes</button>
    }
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || userIsNotAdmin">Save Changes</button>
  </div>

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
    <mat-tab label="General Settings">
      <ng-template mat-tab-label>
        General Settings
        <mat-icon *ngIf="fgGeneral.invalid" color="warn">error</mat-icon>
      </ng-template>
      <app-general [project]="project" [formGroup]="fgGeneral" [resetEvent]="resetEvent"></app-general>
    </mat-tab>
    <mat-tab label="Canons">
      <ng-template mat-tab-label>
        Canons
        <mat-icon *ngIf="fgCanons.invalid" color="warn">error</mat-icon>
      </ng-template>
      <app-canons [project]="project" [formGroup]="fgCanons" [resetEvent]="resetEvent"></app-canons>
    </mat-tab>
    <mat-tab label="Parsing Formats">
      <ng-template mat-tab-label>
        Parsing Formats
        <mat-icon *ngIf="fgParsingFormats.invalid" color="warn">error</mat-icon>
      </ng-template>
      <app-parsing-formats [project]="project" [formGroup]="fgParsingFormats" [resetEvent]="resetEvent"></app-parsing-formats>
    </mat-tab>
    <mat-tab label="Publication Configurations">
      <ng-template mat-tab-label>
        Publication Configurations
        <mat-icon *ngIf="fgPublicationConfigurations.invalid" color="warn">error</mat-icon>
      </ng-template>
      <app-publication-configuration-list [project]="project" [formArray]="fgPublicationConfigurations" [resetEvent]="resetEvent" [parsingFormatGroup]="fgParsingFormats"></app-publication-configuration-list>
    </mat-tab>
    <mat-tab label="Project Members">
      <ng-template mat-tab-label>
        Project Members
        <mat-icon *ngIf="fgProjectMembers.invalid" color="warn">error</mat-icon>
      </ng-template>
      <app-project-members [project]="project" [formArray]="fgProjectMembers" [resetEvent]="resetEvent"></app-project-members>
    </mat-tab>
  </mat-tab-group>
</form>
</main>
}